import React, { useContext, useEffect, useRef } from 'react'
import { useHistory } from 'react-router-dom'
import { App } from '@capacitor/app'
import { ModalContext } from '../../../contexts/ModalContext'

// The app launches at '/' before AppRouter redirects to the real landing page. If '/' (or other
// alias routes) enter the nav stack, pressing back lands on them and triggers an immediate
// re-redirect, causing a visible flash. This set must mirror every <Redirect> route in AppRouter.
// TODO: remove this once AppRouter's alias routes are replaced with proper router-level redirects
// (e.g. via a catch-all redirect in the server/capacitor config) so the app never starts at '/'.
const redirectOnlyPaths = new Set(['/', '/consumption', '/spotMargin'])

const effectFix: any = {}

const BackButtonListener: React.FC = () => {
	const { modalOnTop, closeModal } = useContext(ModalContext)
	const sanityTimeOut = useRef<any>()
	const history = useHistory()
	const navHistory = useRef<string[]>([])
	const isNavigatingBack = useRef(false)

	effectFix.container = {
		modalOnTop,
		history,
	}

	useEffect(() => {
		// Initialize with the settled location at mount time (after initial redirects)
		const initialPath = history.location.pathname
		if (!redirectOnlyPaths.has(initialPath)) {
			navHistory.current = [initialPath]
		}

		const unlisten = history.listen(location => {
			if (isNavigatingBack.current) {
				isNavigatingBack.current = false
				return
			}
			if (redirectOnlyPaths.has(location.pathname)) return

			const last = navHistory.current[navHistory.current.length - 1]
			if (location.pathname !== last) {
				navHistory.current.push(location.pathname)
			}
		})

		return unlisten
		// eslint-disable-next-line
	}, [])

	const onBackButton = (ev: any) => {
		if (sanityTimeOut.current) return

		sanityTimeOut.current = setTimeout(() => {
			sanityTimeOut.current = undefined
		}, 50)

		ev.detail.register(10000, () => {
			if (effectFix.container.modalOnTop) {
				closeModal()
				return
			}

			if (navHistory.current.length <= 1) {
					App.minimizeApp()
					return
				}

			navHistory.current.pop()
			const prev = navHistory.current[navHistory.current.length - 1]
			isNavigatingBack.current = true
			effectFix.container.history.push(prev)
		})
	}

	useEffect(() => {
		document.addEventListener('ionBackButton', onBackButton)

		return () => {
			document.removeEventListener('ionBackButton', onBackButton)
		}
		// eslint-disable-next-line
	}, [])

	return null
}
export default BackButtonListener
